var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayUsd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#52C41A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3877_1468",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3877_1468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.34997 16V14.5667C8.76108 14.4333 8.25275 14.1778 7.82497 13.8C7.39719 13.4222 7.0833 12.8889 6.8833 12.2L8.11663 11.7C8.2833 12.2333 8.53052 12.6389 8.8583 12.9167C9.18608 13.1944 9.61663 13.3333 10.15 13.3333C10.6055 13.3333 10.9916 13.2306 11.3083 13.025C11.625 12.8194 11.7833 12.5 11.7833 12.0667C11.7833 11.6778 11.6611 11.3694 11.4166 11.1417C11.1722 10.9139 10.6055 10.6556 9.71663 10.3667C8.76108 10.0667 8.10552 9.70833 7.74997 9.29167C7.39441 8.875 7.21663 8.36667 7.21663 7.76667C7.21663 7.04444 7.44997 6.48333 7.91663 6.08333C8.3833 5.68333 8.86108 5.45556 9.34997 5.4V4H10.6833V5.4C11.2389 5.48889 11.6972 5.69167 12.0583 6.00833C12.4194 6.325 12.6833 6.71111 12.85 7.16667L11.6166 7.7C11.4833 7.34444 11.2944 7.07778 11.05 6.9C10.8055 6.72222 10.4722 6.63333 10.05 6.63333C9.56108 6.63333 9.18886 6.74167 8.9333 6.95833C8.67775 7.175 8.54997 7.44444 8.54997 7.76667C8.54997 8.13333 8.71663 8.42222 9.04997 8.63333C9.3833 8.84444 9.96108 9.06667 10.7833 9.3C11.55 9.52222 12.1305 9.875 12.525 10.3583C12.9194 10.8417 13.1166 11.4 13.1166 12.0333C13.1166 12.8222 12.8833 13.4222 12.4166 13.8333C11.95 14.2444 11.3722 14.5 10.6833 14.6V16H9.34997Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayUsd);
export default __webpack_public_path__ + "static/media/payUsd.837b4b11818e3dee43fd656a7bf580da.svg";
export { ForwardRef as ReactComponent };